import { render } from "./TemplateE.vue?vue&type=template&id=3a456f22"
import script from "./TemplateE.vue?vue&type=script&lang=js"
export * from "./TemplateE.vue?vue&type=script&lang=js"
script.render = render

export default script